// What the reader put into a chat from the workspace (lib/chatContextStore.js),
// over its composer as the images it stages stand there: each says what it is
// and names itself, the start of its words on hover (lines kept, and how much
// more there is), and its close takes it out. They go with the next message,
// and that message keeps them under its words (AddedList).
import HoverTooltip from "./HoverTooltip.jsx";
import { KIND_WORD, removeFromChat, useChatTray, wordsPreview } from "../lib/chatContextStore.js";

const CHIP = "inline-flex min-w-0 max-w-[260px] items-center gap-[6px] border border-[color:var(--line)] bg-[color:var(--control-bg)] px-[6px] py-[3px]";
const KIND = "shrink-0 text-[10px] uppercase leading-[14px] tracking-[0.14em] text-[color:var(--muted)]";
const NAME = "min-w-0 truncate text-[11px] leading-[14px] text-[color:var(--ink)]";

function Words({ it }) {
  const { text, rest } = wordsPreview(it.text, it.chars);
  return (
    <span className="grid gap-[4px]" data-chat-tray-words="">
      <span className="whitespace-pre-wrap break-words">{text}</span>
      {rest ? <span className="text-[color:var(--muted)]">{`${rest.toLocaleString("en-US")} more character${rest === 1 ? "" : "s"}`}</span> : null}
    </span>
  );
}

function Item({ it, children = null }) {
  return (
    <HoverTooltip label={it.text ? <Words it={it} /> : it.label || KIND_WORD[it.kind]} placement="top" wide maxWidth={it.chars != null ? 420 : null}>
      <span data-chat-tray-item={it.kind} className={CHIP}>
        <span className={KIND}>{KIND_WORD[it.kind] || "Item"}</span>
        {it.label ? <span className={NAME}>{it.label}</span> : null}
        {children}
      </span>
    </HoverTooltip>
  );
}

/** The tray of the chat `id`, over its composer; nothing while it is empty. */
export default function ChatTray({ id, className = "" }) {
  const items = useChatTray(id);
  if (!id || !items.length) return null;
  return (
    <div data-chat-tray={id} className={`flex flex-wrap gap-[6px] ${className}`}>
      {items.map((it) => (
        <Item key={it.key} it={it}>
          <button
            type="button"
            onClick={() => removeFromChat(id, it.key)}
            aria-label={`Take ${it.label || KIND_WORD[it.kind] || "it"} out of the chat`}
            data-chat-tray-remove={it.key}
            className="cursor-pointer text-[12px] leading-none text-[color:var(--muted-soft)] hover:text-[color:var(--ink)]"
          >
            {"\u00d7"}
          </button>
        </Item>
      ))}
    </div>
  );
}

/** What a sent message was about, under its words: the items, read only. */
export function AddedList({ items }) {
  if (!items?.length) return null;
  return (
    <div data-chat-added="" className="mt-[6px] flex flex-wrap gap-[6px]">
      {items.map((it) => <Item key={it.key} it={it} />)}
    </div>
  );
}
